module.exports = __webpack_public_path__ + "img/housou02.c9eaca49.png";